












import { Inject } from '@cds/common';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';

@Component({
  components: {}
})
export default class nuoxiaoerIndex extends Vue {
  public form = {}
  public tableData: any[] = [];
  public loading: Boolean = true;
  public articleContentVisible: boolean = false;
  private routeLinks = [
    { title: '手册-文章管理', path: '/documentManagement' },
    { title: '手册-文库模块管理', path: '/nuoxiaoer-libraryModuleManagement' },
    { title: '手册-文章目录管理', path: '/nuoxiaoer-articleCatelog' },
    { title: '一线KPI备注管理', path: '/nuoxiaoer-KPIRemark' },
    { title: '一线KPI目录管理', path: '/nuoxiaoer-KPIFolderManagement' },
    { title: '一线KPI考核项内容管理', path: '/nuoxiaoer-KPIContentManagement' },
    { title: '通知管理', path: '/nuoxiaoer-notifyManagement' },
    { title: '权限管理', path: '/nuoxiaoer-modulePermissionManagement' },
    { title: '反馈管理', path: '/nuoxiaoer-feedbackManagement' },
    { title: '用户行为日志新版', path: '/nuoxiaoer-buddyAIStatisticsNew' },
    
  ]

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  public async created(): Promise<void> {
  }

  private mounted() {
  }
}
